//@ts-ignore
import Swiper, { Pagination, Navigation } from "swiper";
import { renderPaginationDot } from "../../../src/js/utils/swiper-pagination-dot";

const selectors: Record<"slider", string> = {
  slider: "[data-ui-video-and-image-slider]",
};

const init = () => {
  Swiper.use([Pagination, Navigation]);

  const sliders = document.querySelectorAll(selectors.slider);

  if (!sliders) return;

  sliders.forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: "auto",
      spaceBetween: 24,
      loop: false,

      pagination: {
        el: "[data-swiper-pagination]",
        clickable: true,
        renderBullet: renderPaginationDot,
        bulletActiveClass: "active",
        bulletClass: "bullet",
      },

      navigation: {
        nextEl: "[data-ui-video-and-image-slider] [data-swiper-navigation-next]",
        prevEl: "[data-ui-video-and-image-slider] [data-swiper-navigation-prev]",
      },
    });
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
